import React from "react";

const subscriptions = [
  {
    title: "Subscripción 1",
    description: "El costo de la mensualidad está sujeto a las dimensiones del vehículo.",
    benefits: [
      "4 Lavados luxury",
      "El abrillantado se efectúa solo una vez dentro del combo",
    ],
  },
  {
    title: "Subscripción 2",
    description: "El costo de la mensualidad está sujeto a las dimensiones del vehículo.",
    benefits: ["3 Lavados luxury", "1 Techo", "1 Llantas", "1 Día de campo"],
  },
];

const Subscriptions: React.FC = () => {
  return (
    <section className="bg-[rgb(25,24,31)] text-white py-4 px-4">
      <h2 className="text-4xl font-bold text-center mb-12">
        Modelos de Suscripción
      </h2>
      <div className="flex flex-col lg:flex-row justify-center gap-8 items-stretch">
        {subscriptions.map((subscription, index) => {
          // Crear el mensaje y enlace de WhatsApp
          const whatsappMessage = `Hola! Me contacto para poder suscribirme a la ${subscription.title}`;
          const whatsappLink = `https://wa.me/541126413277?text=${encodeURIComponent(
            whatsappMessage
          )}`;

          return (
            <div
              key={index}
              className="bg-[rgb(35,35,45)] p-6 rounded-2xl shadow-lg hover:shadow-xl transition-transform transform hover:-translate-y-3 ease-in-out duration-300 max-w-sm w-full min-h-[300px] flex flex-col justify-between"
            >
              {/* Contenido Superior */}
              <div className="flex-grow">
                <h3 className="text-2xl font-bold mb-2 text-yellow-500">
                  {subscription.title}
                </h3>
                <p className="text-gray-300 italic mb-4">
                  {subscription.description}
                </p>
                <ul className="text-gray-300 mb-6 space-y-2">
                  {subscription.benefits.map((benefit: string, idx: number) => (
                    <li key={idx} className="flex items-start">
                      <span className="mr-2 text-yellow-500">•</span>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Ahorros y Botón */}
              <div className="mt-auto">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full py-2 px-4 bg-yellow-500 text-black rounded-full font-semibold hover:bg-yellow-400 transition-colors text-center block"
                >
                  Suscribirse
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Subscriptions;
